<template>
    <div class="me-2 d-block d-md-none">
        <a href="javascript:void(0);" @click="routeBacktoConnect"><i class="fas fa-chevron-left"></i></a>
    </div>
    <AvaInitials
        :initialsType="activeConversation?.conversationType"
        :user="getUser(activeConversation?.loginIds[0])"
        :showStatus="activeConversation?.isDraftConversation ? false : true"
        :isDraftConv="activeConversation?.isDraftConversation"
    />
    <div class="ms-2">
        <div class="d-flex align-items-center">
            <h6 class="mb-0 black-text fw-semibold" v-if="activeConversation?.title?.length > 0">
                {{ activeConversation?.title }}
            </h6>
            <h6 class="mb-0 black-text fw-semibold" v-else-if="activeConversation?.loginIds.length">
                {{ formatConversationTitle(activeConversation?.loginIds, 100) }}
            </h6>
            <h6 class="mb-0 black-text weight-600" v-else-if="activeConversation?.isDraftConversation">New Chat</h6>
            <h6 class="mb-0 black-text fw-semibold" v-else>Just You</h6>
            <img
                class="cursor-pointer ps-2"
                src="../../../../../assets/images/chat/edit-pencil-grey.svg"
                v-if="
                    activeConversation?.conversationType == ConversationTypeEnum.GroupConversation &&
                    !activeConversation?.hasUserLeftChat &&
                    !showCallHeader.show
                "
                @click="handleEditGroupNameClick"
            />
            <div
                v-if="
                    activeConversation?.conversationType == ConversationTypeEnum.GroupConversation &&
                    showEditGroupPopup &&
                    !activeConversation?.hasUserLeftChat
                "
                class="edit-group-name"
            >
                <span class="font-size-sm"
                    >Group name
                    <a
                        tabindex="0"
                        href="javascript:void(0);"
                        role="button"
                        v-custom-popover="{ content: groupNameTooltip, className: 'info-popup' }"
                    >
                        <i class="fas fa-info-circle text-primary ms-2"></i> </a
                ></span>
                <input
                    type="text"
                    class="form-control mt-1"
                    placeholder="Enter group name"
                    v-model="newGroupName"
                    v-focus
                    maxlength="250"
                    v-alphanumeric-dash-space-only
                    :class="`${!v$.newGroupName.$error ? ' mb-3' : 'field-invalid'}`"
                    @blur="v$.newGroupName.$touch"
                />
                <div v-if="v$.newGroupName.$error" class="field-invalid my-1">Group name is required.</div>
                <div class="d-flex justify-content-end">
                    <button class="btn btn-light border border-secondary me-2" @click="cancel()">Cancel</button>
                    <button
                        class="btn btn-primary border border-primary"
                        :disabled="isSavingGroupName || !isNameUpdated"
                        @click="updateGroupName()"
                    >
                        <span v-show="isSavingGroupName" class="spinner-border spinner-border-sm"></span>
                        {{ !isSavingGroupName ? "Save" : "Saving.." }}
                    </button>
                </div>
            </div>
        </div>
        <small class="conversation-users" v-if="activeConversation?.title?.length > 0 && !activeConversation.isMuted">{{
            visibleList
        }}</small>
        <a
            tabindex="0"
            href="javascript:void(0);"
            role="button"
            v-if="hiddenCount > 0 && !activeConversation.isMuted"
            v-custom-popover="{ content: hiddenList }"
        >
            <span class="conversation-users black-text fw-semibold">+ {{ hiddenCount }}</span>
        </a>
        <span class="muted-text" v-if="activeConversation.isMuted"
            ><img style="width: 0.9rem" src="../../../../../assets/images/chat/muted-bell.svg" />
            <span>&nbsp;Muted</span></span
        >
    </div>
    <div class="ms-auto d-flex align-items-center">
        <AudioVideoConferencing :room-name-template="roomNameTemplate" />
        <div>
            <i
                :class="`fas fa-ellipsis-h font-size-lg ms-1 ms-md-3 pt-1 ps-md-1 cursor-pointer chat-options-btn ${
                    isCallOngoing ? 'text-white' : ''
                }`"
                data-bs-toggle="dropdown"
                v-if="!activeConversation?.isAxxessConversation"
            ></i>
            <div class="dropdown-menu py-1" aria-labelledby="Chat-Options">
                <a
                    class="dropdown-item font-size-sm bulk-reassign"
                    href="javascript:void(0);"
                    id="view-shared-files"
                    v-if="!activeConversation?.isDraftConversation"
                    @click="viewSharedFiles"
                >
                    View Shared Files
                </a>
                <a
                    class="dropdown-item font-size-sm"
                    href="javascript:void(0);"
                    id="delete-conversation"
                    @click="deleteConversation"
                >
                    Delete
                </a>
                <a
                    class="dropdown-item font-size-sm"
                    href="javascript:void(0);"
                    id="mute-conversation"
                    v-if="!activeConversation?.hasUserLeftChat && !activeConversation?.isDraftConversation"
                    @click="toggleMute"
                >
                    {{ activeConversation.isMuted ? "Unmute" : "Mute" }} Chat
                </a>
            </div>
        </div>
    </div>
</template>

<style lang="scss" src="./ConversationHeader.scss"></style>
<script lang="ts" src="./ConversationHeader.ts"></script>
